import React from 'react';
import './PageHero.css';

const heroImage = require('../assets/jetty1.jpg');

interface PageHeroProps {
  title: string;
  subtitle?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ title, subtitle }) => {
  return (
    <section className="page-hero">
      <div 
        className="page-hero-background"
        style={{ 
          backgroundImage: `url(${heroImage})`
        }}
      ></div>
      <div className="page-hero-overlay"></div>
      <div className="page-hero-content">
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero;

